import { cva } from "class-variance-authority";

export const historyTimelineVariants = cva("space-y-4", {
  variants: {
    inset: {
      panel: "p-4",
      tab: "py-6",
    },
  },
  defaultVariants: {
    inset: "panel",
  },
});
